import React, { useEffect, useRef, useState } from 'react'
import cn from 'classname'
import styles from './index.module.css'
import BrandStrip from '../brand-strip'
import { mediaProfile, cropStyles, prepareMedia, videoProfileAtTime, videoFitStyles } from '../../utils/media-branding'

export default function BrandedMedia({ className, html }) {
  const media = prepareMedia(html)
  const posterProfile = mediaProfile(media.poster)
  const posterCrop = cropStyles(posterProfile)
  const area = useRef(null)
  const [started, setStarted] = useState(false)
  const [top, setTop] = useState(() => media.profile ? media.profile.top : 0)
  const currentProfile = media.profile ? { ...media.profile, top } : null
  const crop = videoFitStyles(media.profile, currentProfile)

  useEffect(() => {
    setStarted(false)
    setTop(media.profile ? media.profile.top : 0)
    const video = area.current && area.current.querySelector('video')
    if (!video) return undefined
    const revealVideo = () => setStarted(true)
    const syncCrop = time => {
      const profile = videoProfileAtTime(media.profile, time)
      if (profile) setTop(previous => previous === profile.top ? previous : profile.top)
    }
    const updateCrop = () => syncCrop(video.currentTime)
    let frameTicket = null
    if (typeof video.requestVideoFrameCallback === 'function') {
      const onFrame = (now, metadata) => {
        syncCrop(metadata.mediaTime)
        frameTicket = video.requestVideoFrameCallback(onFrame)
      }
      frameTicket = video.requestVideoFrameCallback(onFrame)
    }
    video.addEventListener('playing', revealVideo)
    video.addEventListener('timeupdate', updateCrop)
    video.addEventListener('seeked', updateCrop)
    video.addEventListener('error', revealVideo)
    return () => {
      if (frameTicket !== null && typeof video.cancelVideoFrameCallback === 'function') {
        video.cancelVideoFrameCallback(frameTicket)
      }
      video.removeEventListener('playing', revealVideo)
      video.removeEventListener('timeupdate', updateCrop)
      video.removeEventListener('seeked', updateCrop)
      video.removeEventListener('error', revealVideo)
    }
  }, [media.html, media.profile])

  return (
    <div className={cn(styles.container, className)} data-mrf-branding="site"
      style={{ height: 'auto', aspectRatio: 'auto' }}>
      <BrandStrip />
      <div className={styles.stage} style={crop.stage}>
        <div ref={area}
          className={cn(styles.mediaArea, media.profile && styles.cropped, media.profile && styles.fitted)}
          style={{ ...crop.viewport, ...crop.media }}
          dangerouslySetInnerHTML={{ __html: media.html }} />
        {media.poster && !started && (
          <div className={styles.poster} aria-hidden="true">
            <div className={styles.posterSize}
              style={{ aspectRatio: posterProfile
                ? `${posterProfile.width} / ${posterProfile.height - posterProfile.top}`
                : '4 / 5' }}>
              <div className={cn(styles.posterArea, posterProfile && styles.croppedPoster)}
                style={posterCrop.viewport}>
                <img src={media.poster} alt="" style={posterCrop.media} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
